import * as i0 from '@angular/core';
import { Component, Input, InjectionToken, NgModule, Optional, Inject } from '@angular/core';
import isNil from 'lodash/isNil';
import * as i1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import flatten from 'lodash/flatten';

const DEFAULT_VIEWBOX_SIZE = 1792;
function CREATE_CUSTOM_ICON(options) {
    return {
        icon: [
            options.width || DEFAULT_VIEWBOX_SIZE,
            options.height || DEFAULT_VIEWBOX_SIZE,
            [],
            null,
            options.svg
        ],
        prefix: 'dz',
        iconName: options.iconName
    };
}

class DzIconComponent {
    constructor() {
        this.fixedWidth = false;
    }
    ngOnInit() {
        if (!isNil(this.custom)) {
            this.faIcon = ['dz', this.type];
        }
        else {
            this.faIcon = this.type;
        }
    }
}
DzIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DzIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DzIconComponent, selector: "dz-icon", inputs: { type: "type", custom: "custom", fixedWidth: "fixedWidth" }, host: { classAttribute: "icon" }, exportAs: ["dzIcon"], ngImport: i0, template: `<fa-icon [icon]="faIcon" [fixedWidth]="fixedWidth"></fa-icon>`, isInline: true, components: [{ type: i1.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dz-icon',
                    template: `<fa-icon [icon]="faIcon" [fixedWidth]="fixedWidth"></fa-icon>`,
                    exportAs: 'dzIcon',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        class: 'icon'
                    }
                }]
        }], propDecorators: { type: [{
                type: Input
            }], custom: [{
                type: Input
            }], fixedWidth: [{
                type: Input
            }] } });

const DAISY_ICONS = new InjectionToken('DAISY_ICONS');
class DzIconModule {
    constructor(library, icons = []) {
        const flatIcons = flatten(icons);
        if (flatIcons.length) {
            library.addIcons(...flatIcons);
        }
    }
    static withIcons(...icons) {
        return {
            ngModule: DzIconModule,
            providers: [{ provide: DAISY_ICONS, useValue: icons, multi: true }]
        };
    }
}
DzIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconModule, deps: [{ token: i1.FaIconLibrary }, { token: DAISY_ICONS, optional: true }], target: i0.ɵɵFactoryTarget.NgModule });
DzIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconModule, declarations: [DzIconComponent], imports: [CommonModule, FontAwesomeModule], exports: [DzIconComponent] });
DzIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconModule, imports: [[CommonModule, FontAwesomeModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DzIconComponent],
                    imports: [CommonModule, FontAwesomeModule],
                    exports: [DzIconComponent]
                }]
        }], ctorParameters: function () { return [{ type: i1.FaIconLibrary }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DAISY_ICONS]
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { CREATE_CUSTOM_ICON, DAISY_ICONS, DzIconComponent, DzIconModule };
